"use client"
import { useState } from "react";
import { useSession } from "next-auth/react";
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Divider from '@mui/material/Divider';
import { Box, Typography } from "@mui/material";
import { Logout } from "@/helpers/auth/Logout";

const initialsOf = (name?: string, email?: string) => {
    const source = (name || email || "").trim();
    if (!source) return "?";
    const parts = source.split(/\s+/).filter(Boolean);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const AvatarUser = () => {
    const { data: session } = useSession();
    const user = session?.user as any;

    const fullName = [user?.given_name, user?.family_name].filter(Boolean).join(" ") || user?.name;
    const email = user?.email;

    const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <Box sx={{ flexGrow: 0 }}>
            <Tooltip title={fullName || "Mi cuenta"}>
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar sx={{ bgcolor: "#104aa5", width: 36, height: 36, fontSize: 14 }}>
                        {initialsOf(fullName, email)}
                    </Avatar>
                </IconButton>
            </Tooltip>
            <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
            >
                {(fullName || email) && (
                    <Box sx={{ px: 2, py: 1, maxWidth: 240 }}>
                        {fullName && (
                            <Typography sx={{ fontWeight: 600, fontSize: 14 }} noWrap>
                                {fullName}
                            </Typography>
                        )}
                        {email && (
                            <Typography sx={{ fontSize: 12, color: "text.secondary" }} noWrap>
                                {email}
                            </Typography>
                        )}
                    </Box>
                )}
                {(fullName || email) && <Divider />}

                <MenuItem onClick={() => Logout()}>
                    <Typography sx={{ fontSize: 14 }}>Cerrar sesión</Typography>
                </MenuItem>
            </Menu>
        </Box>
    )
}
